import axios from 'axios'
require('dotenv').config()
const {
    REACT_APP_API_URL
} = process.env

export const create = async (winnerId, loserId) => {
    let data = {
        winnerId,
        loserId
    }

    return axios.create({
        headers: {
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        json: true
    }).post(`${REACT_APP_API_URL}/v1/battle`, data)
        .then(response => {
            return response
        })
        .catch(err => {
            throw err
        })
}

export const updateScore = async (id, score, battle_status) => {

    let data = {
        id,
        score,
        battle_status
    }

    return axios.create({
        headers: {
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        json: true
    }).post(`${REACT_APP_API_URL}/v1/battle/score`, data)
        .then(response => {
            return response
        })
        .catch(err => {
            throw err
        })
}

export const renderBattle = () => {
    return axios.create({
        headers: {
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        json: true
    }).get(`${REACT_APP_API_URL}/v1/battle`)
        .then(response => {
            return response
        })
        .catch(err => {
            throw err
        })
}